export default "__VITE_ASSET__DIXsesx0__"